/*
 * @Descripttion:
 * @version:
 * @Author: linxi
 * @email: 2194421430@qq.com
 * @Date: 2021-04-29 14:08:18
 * @LastEditors: linxi
 * @LastEditTime: 2025-09-18 11:43:32
 */
import { Popover, Select } from "antd";
import React from "react";
import { EditableColumnType } from "../../compnents/list/EditableList";
import "../putstorelist/notshow.css";
import styles from './Qingdou.module.css'
import { useSelector } from "react-redux";
import { selectSettings } from "../user/setting/settingSlice";
import { Checks } from "../../models/setting";
const { Option } = Select;

// 新老目录展示方式 (老目录没有区分药品类别/无型号)
export const getProcuctInfo = (item: any, settings: any) => {
  const packSpec = item.packSpec ? item.packSpec : '-'
  const spec = item.spec ? item.spec : '-'
  const doseCategory = item.doseCategory ? item.doseCategory : '-'
  const tenantSupplierName = item.tenantSupplierName ? item.tenantSupplierName : '-'

  if (settings?.[Checks.MLKG] == 1) {
    // 生产厂家 + 包装规格 + 剂型 
    return tenantSupplierName + '/' + packSpec + '/' + doseCategory
  } else {
    return tenantSupplierName + '/' + spec + '/' + doseCategory
  }
}

export const QingDouColumns = (): EditableColumnType<any>[] => {
  return [
    {
      title: "序号",
      dataIndex: "",
      align: "center",
      width: "5%",
      render: (text: any, record: any, index: number) => `${index + 1}`,
    },
    {
      title: "产品信息",
      align: "center",
      width: "20%",
      ellipsis: true,
      dataIndex: "productInfo",
    },
    {
      title: "批号",
      align: "center",
      width: "5%",
      dataIndex: "batchNo",
    },
    {
      title: "库存数量",
      align: "center",
      dataIndex: "count",
    },
    {
      title: "售价",
      align: "center",
      dataIndex: "retailPrice",
    },
    {
      title: "操作",
      align: "center",
      dataIndex: "",
      render: (_, t) => {
        if (t.targetInventoryLedgerId) {
          return "装斗";
        } else {
          return "清斗";
        }
      },
    },
    {
      title: "目标批次",
      align: "center",
      dataIndex: "targetBatchNo",
      ellipsis: true,
      render: (_, t) => {
        return t.targetBatchNo > 0 ? t.targetBatchNo : "";
      },
    },
    {
      title: "目标库存信息",
      align: "center",
      dataIndex: "targetProductInfo",
      ellipsis: true,
      render: (_, t) => {
        return t.targetProductInfo ? t.targetProductInfo : "";
      },
    },
    {
      title: "操作时间",
      align: "center",
      dataIndex: "createTime",
    },
  ];
};

// 添加中药清斗
export const ModalColumnsOne = (): EditableColumnType<any>[] => {

  const settings = useSelector(selectSettings)

  return [
    {
      title: "序号",
      align: "center",
      render: (text: any, record: any, index: number) => `${index + 1}`,
      width:'3rem',
    },
    {
      title: "商品信息",
      dataIndex: "producInfo",
      render: function Element(_, record) {
        return (
          <div>
            <div className={styles.nameText}>{record.name}</div>
            <div className={styles.productText}>
             {getProcuctInfo(record, settings)}
            </div>
          </div>
        );
      },
    },
    {
      title: "批号",
      align: "center",
      dataIndex: "batchNo",
    },
    {
      title: "库存数量",
      align: "center",
      dataIndex: "count",
    },
    {
      title: "售价",
      align: "center",
      dataIndex: "retailPrice",
    },
    {
      title: "操作",
      align: "center",
      render: (_, t) => {
        return t.flag === 1 ? "清斗" : "装斗";
      },
    },
  ];
};

// 添加中药装斗
export const ModalColumnsTwo = (
  onclick: (text: string, t: any) => void
): EditableColumnType<any>[] => {

    const settings = useSelector(selectSettings)


  return [
    {
      title: "序号",
      align: "center",
      width:'3rem',
      ellipsis:true,
      render: (text: any, record: any, index: number) => `${index + 1}`,
    },
    {
      title: "商品信息",
      width: '14rem',
      ellipsis: true,
      dataIndex: "producInfo",
      render: function Element(_, record) {
        return (
          <Popover content={
            <div>
              <div className={styles.popoverNameText}>{record.name}</div>
              <div className={styles.popoverProductText}>
                {getProcuctInfo(record, settings)}
              </div>
            </div>
          }>
            <div>
              <div className={styles.nameText}>{record.name}</div>
              <div className={styles.productText}>
                {getProcuctInfo(record, settings)}
              </div>
            </div>
          </Popover>
        );
      },
    },
    {
      title: "批号",
      align: "center",
      width:'4rem',
      ellipsis:true,
      dataIndex: "batchNo",
    },
    {
      title: "库存数量",
      align: "center",
      width:'4rem',
      ellipsis:true,
      dataIndex: "count",
    },
    {
      title: "售价",
      align: "center",
      width:'4rem',
      ellipsis:true,
      dataIndex: "retailPrice",
    },
    {
      title: "操作",
      align: "center",
      width:'3rem',
      ellipsis:true,
      render: (_, t) => {
        return t.flag === 1 ? "清斗" : "装斗";
      },
    },
    // {
    //   title: "台账Id",
    //   dataIndex: "tenantInventoryLedgerId",
    //   className: "notshow",
    // },
    // {
    //   title: "单据Id",
    //   dataIndex: "tenantInventoryReceiptsId",
    //   className: "notshow",
    // },
    // {
    //   title: "物资Id",
    //   dataIndex: "tenantMaterialsCatalogId",
    //   className: "notshow",
    // },
    {
      title: "选择目标批次",
      align: "center",
      dataIndex: "flag",
      editable: true,
      width:'16rem',
      ellipsis:true,
      onSave: (prev, next) => {
        onclick("edit", { prev, next });
      },
      render: function Element(_, t) {
        const optionList = t?.outInvCleanListTargetList;
        return (
          <Select
            dropdownClassName={styles.select}
            style={{ width: "100%" }}
            placeholder="产品信息|批次号|数量|单位"
            defaultValue={0}
            onSelect={(value: any) => {
              const selectItem = t?.outInvCleanListTargetList.filter(
                (v: any, i: number) => i === value
              )[0];
              const next = selectItem;
              onclick("edit", { prev: t, next });
            }}
          >
            {optionList ? (
              optionList?.map((v: any, i: number) => (
                <>
                  {/* <Option value={23} disabled>
                    批次号库存|数量|单位
                  </Option> */}
                  <Option value={i} key={i}>
                    {`${v?.productInfo}${v?.productInfo ? '|' : ''}
                      ${v?.targetBatchNo}${v?.targetBatchNo ? '|' : ''}
                      ${v?.targetCount}${v?.targetCount ? '|' : ''}
                      ${v?.targetAccountUnit}`}
                  </Option>
                </>
              ))
            ) : (
              <></>
            )}
          </Select>
        );
      },
    },
  ];
};
